import axios from 'axios'

const baseURL = process.env.VUE_APP_CMS_API_URL

const apiClient = axios.create({
  baseURL: `${baseURL}`,
  timeout: 10000
})

function getPageDetails(partner) {
  return apiClient.get('/whitelabels/' + partner + '/')
}

function getContactDetails() {
  return axios.get(`${baseURL}/core/settings/`)
}

export {getPageDetails, getContactDetails}
